export default __webpack_public_path__ + "static/media/consolidated_scan.3b310ed2.svg";